import React from "react";
import NumaMascot from "@/components/NumaMascot";

/**
 * Without this, a render error anywhere leaves a blank page and the author has
 * no idea whether their draft survived. It did: the text lives on the server.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("NUMA: errore di rendering", error, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-paper px-6">
        <div className="numa-panel max-w-md p-8 text-center">
          <div className="mb-5 flex justify-center">
            <NumaMascot size={72} className="numa-mark" variant={0} />
          </div>
          <h1 className="font-serif-display text-xl text-ink">Qualcosa si è interrotto</h1>
          <p className="mt-2 text-[13.5px] leading-relaxed text-ink-muted">
            L'interfaccia ha incontrato un errore imprevisto. Il tuo lavoro è salvato sul
 server: ricaricando la pagina lo ritrovi dove l'avevi lasciato.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="numa-btn  mt-6 h-9 px-4"
          >
            Ricarica
          </button>
          {process.env.NODE_ENV !== "production" && (
            <pre className="mt-5 overflow-x-auto rounded border border-line bg-surface-2 p-3 text-left text-[11px] text-ink-muted">
              {String(this.state.error?.stack || this.state.error)}
            </pre>
          )}
        </div>
      </div>
    );
  }
}
